export const GET_CUSTOMER_CART_QUERY = `
query {
  customerCart {
    id
  }
}
`;
